<div class="dialog-loading" *ngIf="(loading$ | async)">
  <mat-spinner diameter="36"></mat-spinner>
</div>

<div class="dialog-title-content" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <div class="dialog-title">{{'modules.crm.contacts.contactDialog.title' | translate}}</div>
  <div class="dialog-close" (click)="minimize()" *ngIf="data.edit">
    <mat-icon>minimize</mat-icon>
  </div>
  <div class="dialog-close" (click)="closeDialog(false)">
    <mat-icon>close</mat-icon>
  </div>
</div>

<div class="dialog-content no-overflow" [ngClass]="{'no-bottom-padding' : data.edit}">
  <div class="no-overflow full-height df gap20">
    <div class="scrollable grow df-c" #scrollableContent>
      <form [formGroup]="contactsForm" class="dialog-form scroll-content-padding df-c gap15" autocomplete="off">

        <div class="df gap20">
          <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width">
            <mat-label>{{'modules.crm.contacts.contactDialog.labels.lastName' | translate}}</mat-label>
            <input type="text" matInput formControlName="lastName">
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width">
            <mat-label>{{'modules.crm.contacts.contactDialog.labels.firstName' | translate}}</mat-label>
            <input type="text" matInput formControlName="firstName">
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width">
            <mat-label>{{'modules.crm.contacts.contactDialog.labels.parentalName' | translate}}</mat-label>
            <input type="text" matInput formControlName="parentalName">
          </mat-form-field>
        </div>

        <div class="df gap20">
          <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width grow">
            <mat-label>{{'modules.crm.contacts.contactDialog.labels.source' | translate}}</mat-label>
            <mat-select class="select-panel" panelClass="dialog-select-panel" disableOptionCentering="true" formControlName="source">
              <mat-option [value]="'CRM'">{{'modules.crm.contacts.sources.CRM' | translate}}</mat-option>
              <mat-option [value]="'HOMEPAGE_REQUEST'">{{'modules.crm.contacts.sources.HOMEPAGE_REQUEST' | translate}}</mat-option>
              <mat-option [value]="'WEBINAR'">{{'modules.crm.contacts.sources.WEBINAR' | translate}}</mat-option>
              <mat-option [value]="'RECOMMENDATION'">{{'modules.crm.contacts.sources.RECOMMENDATION' | translate}}</mat-option>
              <mat-option [value]="'REQUEST'">{{'modules.crm.contacts.sources.REQUEST' | translate}}</mat-option>
              <mat-option [value]="'DEMO'">{{'modules.crm.contacts.sources.DEMO' | translate}}</mat-option>
              <mat-option [value]="'MOBILE_APP_REQUEST'">{{'modules.crm.contacts.sources.MOBILE_APP_REQUEST' | translate}}</mat-option>
              <mat-option [value]="'YOU_CONTROL'">{{'modules.crm.contacts.sources.YOU_CONTROL' | translate}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width grow">
            <mat-label>{{'modules.crm.contacts.contactDialog.labels.type' | translate}}</mat-label>
            <mat-select class="select-panel" panelClass="dialog-select-panel" disableOptionCentering="true" formControlName="type">
              <mat-option [value]="'GOVERNMENT_HEAD'">{{'modules.crm.contacts.types.GOVERNMENT_HEAD' | translate}}</mat-option>
              <mat-option [value]="'ACCOUNTANT'">{{'modules.crm.contacts.types.ACCOUNTANT' | translate}}</mat-option>
              <mat-option [value]="'GOVERNMENT_MEMBER'">{{'modules.crm.contacts.types.GOVERNMENT_MEMBER' | translate}}</mat-option>
              <mat-option [value]="'LEAD_GROUP_MEMBER'">{{'modules.crm.contacts.types.LEAD_GROUP_MEMBER' | translate}}</mat-option>
              <mat-option [value]="'TENANT'">{{'modules.crm.contacts.types.TENANT' | translate}}</mat-option>
              <mat-option [value]="'UFO'">{{'modules.crm.contacts.types.UFO' | translate}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width">
          <mat-label>{{'modules.crm.contacts.contactDialog.labels.address' | translate}}</mat-label>
          <input type="text" matInput formControlName="address">
        </mat-form-field>

        <div class="df gap20">

          <autocomplete-item-field class="grow"
                                   [dataType]="'MANAGER'"
                                   label="{{'modules.crm.contacts.contactDialog.labels.manager' | translate}}"
                                   [readonly]="!checkPermissions('CONTACT_ADD') && !checkPermissions('CONTACT_EDIT') && !checkPermissions('CRM_MANAGER_EDIT')"
                                   formControlName="manager">
          </autocomplete-item-field>
        </div>
      </form>
      <div class="scroll-content-padding df gap20">
        <form style="width: 240px; min-width: 240px"
              [formGroup]="phonesForm"
              class="dialog-form no-overflow df-c gap10" autocomplete="off">
          <div class="form-array-controls-container" formArrayName="phonesFormControls" *ngFor="let phonesFormControl of getPhonesControls(); let i = index">
            <div [formGroupName]="i" class="df gap10 jc-s ai-c">
              <app-phone-number-field formControlName="phone"
                                      class="grow"
                                      [appearance]="'outline'"
                                      [callAllowed]="true"
                                      [label]="'modules.crm.contacts.contactDialog.labels.phones'">
              </app-phone-number-field>
              <div>
                <button class="delete-form-control-button" (click)="deletePhonesArrayItem(i)" [disabled]="getPhonesControlsQuantity() < 2">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="dialog-subtitle-label df jc-sb ai-c">
            <span class="add-row" (click)="addPhonesArrayItem()">{{'common.addItem' | translate}}</span>
          </div>
        </form>
        <form [formGroup]="emailsForm"
              class="dialog-form no-overflow df-c gap10 grow" autocomplete="off">
          <div class="form-array-controls-container" formArrayName="emailsFormControls" *ngFor="let emailsFormControl of getEmailsControls(); let i = index">
            <div [formGroupName]="i" class="df gap10 jc-s ai-c">
              <mat-form-field appearance="outline" floatLabel="always" class="full-width no-padding">
                <mat-label>{{'modules.crm.contacts.contactDialog.labels.email' | translate}}</mat-label>
                <input matInput formControlName="email">
              </mat-form-field>

              <div class="df ai-c jc-c">
                <button class="delete-form-control-button" (click)="deleteEmailsArrayItem(i)" [disabled]="getEmailsControlsQuantity() < 2">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="dialog-subtitle-label df jc-sb ai-c">
            <span class="add-row" (click)="addEmailsArrayItem()">{{'common.addItem' | translate}}</span>
          </div>
        </form>
      </div>
    </div>
    <ng-container *ngIf="data.edit && data?.contactToEdit?.id">
      <app-crm-feed
              class="df"
        [permissions]="permissions$ | async"
        [currentUser]="currentUser$ | async"
        [reference]="{referenceId: data?.contactToEdit?.id, referenceType: 'CONTACT'}"
        [referenceData]="{id: data?.contactToEdit?.id, name: data?.contactToEdit?.lastName +  ' ' + data?.contactToEdit?.firstName, description: data?.contactToEdit?.phones?.join(', ')}"
      >
      </app-crm-feed>
    </ng-container>
  </div>
</div>

<div class="buttons-row df jc-sb ai-c gap20" *ngIf="!readonlyFlag">
  <div class="df jc-s ai-c">
    <mat-checkbox [formControl]="archived">{{'Архівний'}}</mat-checkbox>
  </div>
  <div class="df gap20">
    <button class="default-button apply-button-flat" (click)="submitForm(false)" [disabled]="(contactsForm.invalid || phonesForm.invalid || emailsForm.invalid) && (loading$ | async) === false">
      {{'common.save' | translate}}
    </button>
    <button class="default-button apply-button" (click)="submitForm(true)" [disabled]="(contactsForm.invalid || phonesForm.invalid || emailsForm.invalid) && (loading$ | async) === false">
      {{'common.saveAndClose' | translate}}
    </button>
  </div>
</div>
